import { NgModule } from "@angular/core";
import { OfferRequirementsSectionComponent } from "./offer-requirements-section.component";
import { SubmissionDetailsSharedComponentsModule } from "../../components/submission-details-shared-components.module";

@NgModule({
  imports: [
    SubmissionDetailsSharedComponentsModule,
  ],
  declarations: [
    OfferRequirementsSectionComponent
  ],
  exports: [
    OfferRequirementsSectionComponent
  ]
})
export class OfferRequirementsSectionModule { }
